<!-- <svg-icon iconClass="[name]"></svg-icon> -->
<template>
  <svg class="svg-icon" aria-hidden="true" :style="{ width: `${width}`, height: `${height}` }">
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script>
export default {
  name: 'icon-svg',
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: false,
      default: '20px',
    },
    height: {
      type: String,
      required: false,
      default: '20px',
    },
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
  },
}
</script>
<style scoped>
.svg-icon {
  vertical-align: -3px;
  fill: currentColor;
  overflow: hidden;
}
</style>
